import {
  ENUM_CS_ROLE,
  ENUM_KITCHEN_ROLE,
  ENUM_LOGISTICS_ROLE,
  ENUM_SECURITY_ROLE
} from '@cokitchen/cokitchen-auth';

export enum ENUM_ITEM_TYPE {
  FOOD = 'FOOD',
  SHOP = 'SHOP',
  ALL = 'ALL'
}

export enum ENUM_PHONE_METHOD {
  CALL = 'call',
  WHATSAPP = 'whatsapp'
}

export enum ENUM_AM_PM {
  AM = 'AM',
  PM = 'PM'
}

export enum ENUM_STATUS {
  ONGOING = 'ongoing',
  PROCESSING = 'processing',
  PENDING = 'pending',
  READY = 'ready',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  UNPAID = 'unpaid',
  LATE = 'late',
  RECALLED = 'recalled'
}
export enum ENUM_NOTICE_STATUS {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  DRAFT = 'draft'
}
export enum ENUM_KITCHEN_STATUS {
  LATE = 'late',
  UNPAID = 'unpaid',
  PROCESSING = 'processing',
  DISPATCH = 'dispatched',
  PENDING = 'pending',
  RECALLED = 'recalled'
}
export type ALL_STATUS = ENUM_KITCHEN_STATUS | ENUM_STATUS;

export enum ENUM_TRIP_STATUS {
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export enum ENUM_SEARCH_KEY {
  FULL_NAME = 'full_name',
  EMAIL = 'email',
  NAME = 'name',
  ORDER_CODE = 'order_code',
  RIDER_NAME = 'rider_name',
  PHONE_NUMBER = 'phone_number'
}

export type PANEL_ROLES =
  | ENUM_CS_ROLE
  | ENUM_LOGISTICS_ROLE
  | ENUM_KITCHEN_ROLE
  | ENUM_SECURITY_ROLE;

export enum ENUM_PENDING_SOURCE {
  KITCHEN = 'KITCHEN',
  REVIEW = 'REVIEW',
  LOGISTICS = 'LOGISTICS',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  TECH_TEAM = 'TECH_TEAM',
  BANK_AND_FINANCE = 'BANK_AND_FINANCE',
  FC_SHOP = 'FC_SHOP',
  OTHER = 'OTHER'
}

export enum ENUM_INBOUND_ROLE {
  CS = 'CUSTOMER_SERVICE',
  CS_ADMIN = 'CUSTOMER_SERVICE_ADMIN',
  CS_SUPER_ADMIN = 'CUSTOMER_SERVICE_LEAD',
  CS_OUTBOUND = 'CUSTOMER_SERVICE_OUTBOUND',
  CS_INBOUND = 'CUSTOMER_SERVICE_INBOUND'
}

export enum ENUM_BANK_NAMES {
  ACCESS = 'Access Bank',
  GT = 'GT Bank',
  WEMA = 'Wema Bank',
  PROVIDUS = 'Providus Bank',
  HERITAGE = 'Heritage Bank',
  FCMB = 'FCMB',
  '9PSB' = '9 Payment Service Bank',
  STANBIC = 'Stanbic Bank'
}

export enum LIVE_TRIP_ENUM_STATUS {
  ONGOING = 'ongoing',
  PROCESSING = 'processing',
  PENDING = 'pending',
  READY = 'ready'
}

export enum ENUM_ESCALATE_ITEMS {
  WHATSAPP = 'whatsapp',
  EMAIL = 'Email',
  PHONE_CALL = 'Phone call',
  INSTAGRAM = 'Instagram',
  TWITTER = 'Twitter',
  PENDING_TASK = 'Pending Task',
  INBOUND = 'Inbound',
  OUTBOUND = 'Outbound',
  APP_FEEDBACK = 'App Feedback'
}

export enum ENUM_ISSUE_DESTINATION {
  LOGISTICS = 'Logistics',
  KITCHEN = 'Kitchen',
  TECH_TEAM = 'Tech Team',
  FC_SHOP = 'FC Shop',
  CUSTOMER_SERVICE = 'Customer service',
  BANK_AND_FINANCE = 'Bank and Finance',
  HOAX = 'Hoax',
  DESTINATION_OTHER = 'Other'
}

export enum ENUM_ISSUE_SUMMARY {
  PAYMENT_CONFIRMATION_DELAY = 'Payment confirmation delay',
  DELAYED_PREPARATION = 'Delayed preparation',
  PORTIONING = 'Portioning',
  APP_ACCESSIBILITY = 'App Accessibility',
  PAYSTACK_ORDER_NOT_CREATED = 'Paystack order not created',
  DRINK_QUALITY_TASTE = 'Drink Quality/Taste',
  LATE_DELIVERY = 'Late delivery',
  NIGHT_POLICY = 'Night policy',
  INCOMPLETE_ORDER_MISSING_ITEM = 'Incomplete order (Missing item)',
  DRINK_NOT_DELIVERED = 'Drink not delivered',
  ITEM_NOT_PACKED = 'Item not packed',
  WRONG_ORDER_DELIVERED = 'Wrong order delivered',
  WRONG_ORDER_PACKED = 'Wrong order packed',
  RUDE_RIDER = 'Rude rider',
  RIDER_NOT_PICKING_CALLS = 'Rider not picking calls',
  CS_ISSUES_RUDENESS_UNWILLINGNESS_TO_ASSIST = 'CS Issues (Rudeness, unwillingness to assist)',
  SPILLED_MEAL = 'Spilled meal',
  DOUBLE_CARD_PAYMENT = 'Double card payment',
  TRANSFER_ISSUES_NON_RECEIPT_OF_FUNDS_DOUBLE_TRANSFER_ETC = 'Transfer issues (non receipt of funds, double transfer etc)',
  FOOD_QUALITY_TASTE = 'Food Quality / Taste',
  ORDER_STATUS_KITCHEN = 'Order status (Kitchen)',
  ORDER_STATUS_LOGISTICS = 'Order status (Logistics)',
  REFUND_ISSUE_WALLET = 'Refud issue (wallet)',
  REFUND_ISSUE_BANK = 'Refund Issue (Bank)',
  MEAL_AVAILABILITY = 'Meal availabililty',
  ORDER_COMPLETED_BUT_NOT_YET_DELIVERED = 'Order completed but not yet delivered',
  OTP_ISSUE = 'OTP Issue',
  USER_EDUCATION_ON_MEAL = 'User Education on meal',
  ADDRESS_UPDATE = 'Addess update',
  DELIVERY_REQUEST = 'Delivery request',
  RECALLED_ORDER = 'Recalled order',
  SOLD_OUT_ITEM = 'Sold out item',
  PRICE_DISPARITY_ON_APP_ORDERED_ITEM = 'Price disparity on App/Ordered item',
  WRONG_LOCATION_APP_RELATED = 'Wrong location (App related)',
  KITCHEN_TOOK_TOO_LONG_TO_ACCEPT = 'Kitchen took too long to accept',
  LOGISTICS_TOOK_TIME_TO_ASSIGN_DISPATCH_ORDER = 'Logistics took time to assign/dispatch order',
  SWITCHED_OFF_UNABLE_TO_CONTACT_RIDER = 'Switched off (Unable to contact rider)',
  DUPLICATE_ORDER_CREATED = 'Duplicate order created',
  PACKAGING_ISSUES_KITCHEN = 'Packaging issues (kitchen)',
  ORDER_CANCELLATION_REQUEST = 'Order cancellation request',
  MANUAL_CONFIRMATION_PAYMENT_RECEIVED_CARD_NIP = 'Manual confirmation (Payment received card/NIP)',
  MEAL_MODIFICATION = 'Meal Modification',
  MEAL_CUSTOMIZATION = 'Meal Customization',
  MEAL_REPLACEMENT = 'Meal Replacement',
  SWITCH_TO_PICK_UP = 'Switch to Pick up',
  SWITCH_TO_DELIVERY = 'Switch to Delivery',
  FREE_DELIVERY = 'Free Delivery',
  PAIR_ORDER_REQUEST = 'Pair order request',
  SUMMARY_OTHER = 'Other'
}

export enum ENUM_ISSUE_RESOLUTION {
  DELIVERED = 'Delivered',
  MEAL_REPLACEMENT = 'Meal Replacement',
  WALLET_REFUND = 'Wallet Refund',
  BANK_REFUND = 'Bank refund',
  USER_PACIFIED = 'User pacified',
  MEAL_REPACKAGED = 'Meal repacked',
  ORDER_CANCELLED = 'Order cancelled',
  ORDER_RECALLED = 'Order recalled',
  USER_EDUCATION = 'User education',
  PENDING = 'Pending',
  RESOLUTION_OTHER = 'Other'
}

export enum ENUM_KITHEN_TEAMS {
  ALPHA = 'alpha',
  BETA = 'beta',
  CHAI = 'chai'
}

export enum ROSTER_SHIFT {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  NIGHT = 'night'
}
export enum WEEKDAY {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday'
}

export enum WEEKLY_ROSTER_PAGES {
  EDIT = 'Edit',
  REVIEW = 'Review'
}

export enum KITCHEN_STAFF_ROLES {
  TeamLead = 'Team Lead',
  Cook = 'Cook',
  ActingTeamLead = 'Acting Team Lead',
  AssistantTeamLead = 'Assistant Team Lead',
  KitchenAssistant = 'Kitchen Assistant',
  Packer = 'Packer',
  Server = 'Server',
  GrillCook = 'Grill Cook',
  GrillAssistant = 'Grill Assistant',
  Supervisor = 'Supervisor'
}
export enum DAY {
  Sun = 1,
  Mon = 2,
  Tue = 3,
  Wed = 4,
  Thurs = 5,
  Fri = 6,
  Sat = 7
}
export enum FCB_BRAND_TYPE {
  BREAKFAST = 'Breakfast',
  LUNCH = 'Lunch',
  AFTER_HOURS = 'After hours'
}

export enum ENUM_ORDER_PROVIDER {
  chowdeck = 'chowdeck',
  glovo = 'glovo',
  foodcourt = 'foodcourt'
}
export enum ENUM_ORDER_LOG_ACTIONS {
  KITCHEN_VERIFIED = 'kitchen_verified',
  KITCHEN_ACCEPTED = 'kitchen_accepted',
  KITCHEN_COMPLETED = 'kitchen_completed',
  RIDER_ASSIGNED = 'rider_assigned',
  KITCHEN_DISPATCHED = 'kitchen_dispatched',
  RIDER_STARTED = 'rider_started',
  RIDER_ARRIVED = 'rider_arrived',
  ORDER_RECALLED = 'order_recalled'
}
export enum ENUM_RIDER_STATUS {
  AWAITING_APPROVAL = 'AWAITING_IN_PERSON_APPROVAL',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  SCHEDULED = 'SCHEDULED',
  ALL = 'ALL'
}

export enum ENUM_AUTHORIZE_TYPE {
  REJECT = 'REJECT',
  APPROVE = 'APPROVE',
  DELETE = 'DELETE',
  SCHEDULE = 'SCHEDULE'
}

export enum ENUM_KITCHEN_SHIFT {
  MORNING = 'Morning',
  AFTERNOON = 'Afternoon',
  NIGHT = 'Night'
}
